import axios from '@/utils/request';

// 获取首页板块列表
export const getPlates = (data: any) => {
  return axios.request({
    url: 'Home/GetPlates',
    method: 'GET',
    params: data,
  });
};

// 获取学习榜
export const getStudyRank = (data: any) => {
  return axios.request({
    url: 'Home/GetStudyRank',
    method: 'GET',
    params: data,
  });
};

// 获取排行榜
export const getIntegralRank = (data: any) => {
  return axios.request({
    url: 'Home/GetIntegralRank',
    method: 'GET',
    params: data,
  });
};
